import {ActionContext} from "vuex";
import {ContentState} from "./content_module";
import {ContentProvider} from "../../../../../domain/entities/content-provider/content-provider";
import {Content} from "../../../../presentation/views/content/helpers";
import progress from "./progress";
import checkpoint from "./checkpoint";

export class PlayerState {
  contentProvider: ContentProvider | null = null;
  currentContent: Content | null = null;
  playbackRate: number = 1;
  lastPausedTime: number | undefined;
}

const state = new PlayerState();

type PlayerActionContext = ActionContext<PlayerState, ContentState>;

const mutations = {
  SET_CONTENT_PROVIDER(state: PlayerState, contentProvider: ContentProvider) {
    state.contentProvider = contentProvider;
  },

  SET_CURRENT_CONTENT(state: PlayerState, currentContent: Content) {
    state.currentContent = currentContent;
  },

  SET_PLAYBACK_RATE(state: PlayerState, playbackRate: number) {
    state.playbackRate = playbackRate;
  },

  SET_LAST_PAUSED_TIME(state: PlayerState, lastPausedTime: number) {
    state.lastPausedTime = lastPausedTime;
  },
}

const actions = {
  async setPlaybackRate({commit}: PlayerActionContext, playbackRate: number) {
    commit("SET_PLAYBACK_RATE", playbackRate);
  },

  async setLastPausedTime({commit}: PlayerActionContext, lastPausedTime: number) {
    commit("SET_LAST_PAUSED_TIME", lastPausedTime);
  },
};

const getters = {
  contentProvider: (state: PlayerState): ContentProvider | null => state.contentProvider,
  currentContent: (state: PlayerState): Content | null => state.currentContent,
  playbackRate: (state: PlayerState): number => state.playbackRate,
  lastPausedTime: (state: PlayerState): number | undefined => state.lastPausedTime,
};

const modules = {
  progress,
  checkpoint,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
  modules,
}